import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { SelectionList, Text } from '@dixa/lib-shared-habla';
import { memo, useCallback } from 'react';
import { analytics } from 'app/utils/segment';
import { useAnalyticsState } from 'app/views/layout/views/analytics/components/panels/utils/useAnalyticsState/useAnalyticsState';
import { AnalyticsFilterLayout, AnalyticsFilterOptions, } from '../../../../../filter';
import { customAttributesFilterAssets } from '../../utils/customAttributesFilterAssets';
const { operators } = customAttributesFilterAssets['text'];
export const AnalyticsCustomAttributesFilterText = memo(function AnalyticsCustomAttributesFilterText({ field, attribute, defaultOperator, selectedOperator, onChange, onBack, }) {
    const { dashboard } = useAnalyticsState();
    const trackingType = `${field}/${attribute.type}`;
    /**
     * Handles changing the filter operator.
     *
     * If filter is restored to its default state, the filter is removed from
     * the state.
     */
    const handleChangeOperator = useCallback((operator) => {
        onChange({
            op: 'upsert',
            filter: {
                field,
                values: [],
                operator,
                attribute_id: attribute.id,
            },
        });
        analytics.analyticsFilterOperatorUpdated({
            dashboard: dashboard.title,
            type: trackingType,
            operator,
        });
    }, [attribute.id, dashboard.title, field, onChange, trackingType]);
    /** Handles remove the filter from the state. */
    const handleClear = useCallback(() => {
        if (!selectedOperator)
            return;
        onChange({
            op: 'remove',
            filter: {
                field,
                values: [],
                operator: selectedOperator,
                attribute_id: attribute.id,
            },
        });
        analytics.analyticsFilterCleared({
            dashboard: dashboard.title,
            type: trackingType,
        });
    }, [
        attribute.id,
        dashboard.title,
        field,
        onChange,
        selectedOperator,
        trackingType,
    ]);
    return (_jsxs(_Fragment, { children: [_jsx(AnalyticsFilterLayout.Row, { children: _jsx(Text.Paragraph, Object.assign({ variant: "3", subdued: true }, { children: attribute.label })) }), _jsx(AnalyticsFilterLayout.Row, Object.assign({ noPadding: true }, { children: _jsx(SelectionList, Object.assign({ isActive: false }, { children: _jsx(SelectionList.BackItem, { onSelected: onBack }) })) })), _jsx(AnalyticsFilterLayout.Row, Object.assign({ borderTop: true, slottable: true }, { children: _jsx(AnalyticsFilterOptions, { operators: operators, defaultOperator: defaultOperator, selectedOperator: selectedOperator, isMissingSelectedValues: true, isDropdownOpen: true, isDefaultOpen: true, onChangeOperator: handleChangeOperator, onClear: handleClear }) }))] }));
});
